<template>
    <v-row>
        <v-col sm="8">
            <v-card-title>
                {{ data.details.originTown }} <v-icon x-small class="_arrow">fas fa-arrow-right</v-icon>
                {{ data.details.unloadingTown }}
            </v-card-title>
            <v-card elevation="1">
                <v-card-text>
                    <ResultTable
                        :initialHeaders="headers"
                        :items="itemsForTable"
                        :singleClickAction="displayMap"
                        :saveChanges="true"
                        skin="elevation-1"
                    />
                </v-card-text>
            </v-card>
        </v-col>
        <v-col sm="4">
            <v-card elevation="0" class="details-map">
                <v-card-text v-if="marker">
                    <Map :marker="marker" />
                    <div class="informations">
                        <b>{{ $t('trackandtrace.events.eventDetails.deliveryOrder') }} :</b>
                        {{ this.details.delivery_order }}
                        <hr />
                        <b>{{ $t('trackandtrace.events.eventDetails.customerDeliveryAddress') }} :</b>
                        {{ this.details.custom_delivery_address }}
                        <hr />
                        <b>{{ $t('trackandtrace.events.eventDetails.recipientName') }} :</b>
                        {{ this.details.recipient_name }}
                        <hr />
                        <b>{{ $t('trackandtrace.events.eventDetails.deliveryDate') }} :</b>
                        {{ this.details.custom_delivery_date }}
                    </div>
                </v-card-text>
                <v-card-text class="map-explanation" v-else>
                    <v-icon large color="deep-purple darken-4">fas fa-map-marker-alt</v-icon>
                    <br />
                    <br />
                    {{ $t('trackandtrace.events.details-message') }}
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import ResultTable from '@/components/ResultTable';
import Map from '@/components/Map';

export default {
    components: { ResultTable, Map },
    props: ['data'],
    data() {
        return {
            marker: null,
            details: {
                delivery_order: null,
                custom_delivery_address: null,
                recipient_name: null,
                custom_delivery_date: null
            }
        };
    },
    computed: {
        ...mapGetters(['getClientName']),
        headers() {
            return [
                {
                    key: 'trackandtrace.events.header.when',
                    value: 'formattedDate',
                    align: 'center'
                },
                {
                    key: 'trackandtrace.events.header.where',
                    value: 'whereTown',
                    align: 'center'
                },
                {
                    key: 'trackandtrace.events.header.description',
                    value: 'event',
                    align: 'center'
                },
                {
                    key: 'trackandtrace.events.header.comment',
                    value: 'comment',
                    align: 'center'
                },
                {
                    key: 'trackandtrace.events.header.recipient_name',
                    value: 'recipientName',
                    align: 'center'
                },
                {
                    key: 'trackandtrace.events.header.reason_code',
                    value: 'reasonCode',
                    align: 'center'
                }
            ];
        },
        itemsForTable() {
            return this.data.events.map(elt => {
                const item = {};
                item.serviceNumber = elt.serviceNumber;
                item.formattedDate = elt.formattedDate;
                item.whereTown = `${elt.whereTown.referenceValue}`;
                item.event = `${elt.event.referenceValue}`;
                item.comment = `${elt.comment.referenceValue}`;
                item.recipientName = `${elt.recipientName.referenceValue}`;
                item.reasonCode = elt.reasonCode;
                return item;
            });
        }
    },
    methods: {
        displayMap(data) {
            this.marker = data.whereTown;
            this.details.delivery_order = data.serviceNumber;
            this.details.custom_delivery_address = data.whereTown;
            this.details.recipient_name = data.recipientName;
            this.details.custom_delivery_date = data.formattedDate;
        }
    },
    filters: {
        uppercase(value) {
            return value.toUpperCase();
        }
    }
};
</script>

<style lang="scss" scoped>
._arrow {
    margin: 0 10px;
}
.map-explanation {
    text-align: center;
    padding: 40px;
}
.details-map {
    height: 100%;
    background-color: #e8eaf6;
    color: #7c7699;
    .map {
        height: 300px;
        margin-bottom: 16px;
    }
    hr {
        margin: 5px 0;
    }
}
</style>
